import { createFileRoute } from "@tanstack/react-router";

import { requirePermission } from "~/lib/functions/admin-access";
import { adminFunnelHealthReportQueryOptions } from "~/lib/functions/admin-funnel-health";

import { FunnelHealthAdminPage } from "./-components/funnel-health-page";

export const Route = createFileRoute("/admin/funnel-health/")({
  staticData: { title: "Funnel Health" },
  beforeLoad: ({ context }) =>
    requirePermission(context.adminPermissions, "funnel-health:read"),
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(
      adminFunnelHealthReportQueryOptions,
    );
  },
  component: FunnelHealthAdminPage,
});
